import { render, staticRenderFns } from "./AssignmentsTable.vue?vue&type=template&id=79df9bd3"
import script from "./AssignmentsTable.vue?vue&type=script&lang=js"
export * from "./AssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./AssignmentsTable.vue?vue&type=style&index=0&id=79df9bd3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports